import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../redux";
import { useSelector } from "react-redux";
import { updateError } from "../../../redux/reducer/surveyReportReducer";
import { getErrorMessage } from "../../../utils/helpers";
import HeaderSection from "../../../components/header-section";
import ErrorAlertMessage from "../../../components/alertMessageModal/ErrorAlertMessage";
import Header from "../../../components/header";
import SurveyFilterForm from "../../../components/survey/surveyFilterForm";
import SurveyAdminFilterTable from "../../../components/survey/surveyAdminFilterTable";
import SurveyFilterTable from "../../../components/survey/surveyFilterTable";

// Component starts
const SurveyReport = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /**
   * redux hooks.
   */
  const { user } = useSelector((state: any) => state.login);
  const { surveysReport } = useSelector((state: any) => state);
  const { apiError } = surveysReport;

  /**
   * check user modules.
   */
  const isAdminUser =
    user &&
    user.modules &&
    user.modules.includes("FEDERFARMA_ASSOCIAZIONE_PROVINCIALE");

  /**
   * update notificationType value
   */
  const handleClose = () => {
    dispatch(updateError());
  };

  return (
    <>
      {apiError?.key && (
        <ErrorAlertMessage
          icon="info"
          handleClose={handleClose}
          message={
            apiError?.key ? getErrorMessage(apiError) : t("survey-report-error")
          }
        />
      )}
      <Header active={true} titleLogOut={user?.username} />
      <div className="page-title">
        <HeaderSection
          visibleButton={false}
          titleSection={
            isAdminUser
              ? t("headerSection.report")
              : t("headerSection.question")
          }
        />
      </div>

      {/* render survey filter form fields */}
      <SurveyFilterForm isAdminUser={isAdminUser} />

      {/* render surveys table by user permission  */}
      {isAdminUser ? <SurveyAdminFilterTable /> : <SurveyFilterTable />}
    </>
  );
};

export default SurveyReport;
